/**
 * Print Receipt page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';
declare let Tawk_API: any;
/**
 * Services
 */
import { PouchService } from '../services/pouch-service';
import { ElectronService } from 'ngx-electron';
import { DomSanitizer, Title } from '@angular/platform-browser';
@Component({
  selector: 'page-print-receipt',
  templateUrl: 'print-receipt.html',
  styleUrls: ['print-receipt.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PrintReceiptPage {
  navParams = {};
  options: PrintOptions = {
    name: 'Receipt',
    //printerId: 'printer007',
    duplex: true,
    orientation: 'landscape',
    //grayscale: true
  };
  sale: any;
  products = [];
  settings = {
    id: '',
    rev: '',
    company: '',
    address: '',
    phone: '',
    email: '',
    receiptmessage: '',
  };
  issale = true;
  logo = '';

  constructor(injector: Injector, private titleService: Title, private platform: Platform, public modalCtrl: ModalController, private _electronService: ElectronService, public _DomSanitizer: DomSanitizer, private printer: Printer, public db: PouchService, private router: Router, public navCtrl: NavController) {
    let navParams2: any = {};
    if (router.url != '/PrintReceiptPage') {
      navParams2 = injector.get(NavParams);
    }
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
    this.titleService.setTitle(`Print Receipt - ${this.db.gsetting.username} - ${this.db.appinfo.title}`);
    this.sale = this.navParams['sale'];
    if (this.navParams != undefined && this.navParams['ispurchase'] == true) {
      this.issale = false;
    }
  }

  ionViewDidEnter() {
    this.sale.items.map((item) => {
      this.products.push(item);
    });
    let mythis = this;
    if (Tawk_API) {
      Tawk_API.hideWidget();
    }
    // repair
    if (!this.db.gsetting.receipt_company) {
      this.db.gsetting.receipt_company = this.db.gsetting.company;
      this.db.gsetting.receipt_address = this.db.gsetting.address;
      this.db.gsetting.receipt_email = this.db.gsetting.email;
      this.db.gsetting.receipt_phone = this.db.gsetting.phone;
      this.db.update(this.db.gsetting, 'setting');
    }
    window.onafterprint = function () {
      if (Tawk_API) {
        Tawk_API.showWidget();
      }
      mythis.modalCtrl.dismiss();
    };
    if (this.db.gsetting.attachments != undefined && this.db.gsetting.attachments.logo != undefined) {
      this.db.getAttachment('setting', this.db.gsetting.id, 'logo').then((file) => {
        this.blobToDataURL(file, (dataurl) => {
          this.logo = dataurl;
          if (this.navParams != undefined && this.navParams['view'] != true) {
            setTimeout(() => (this.db.print(this.options), 500));
          }
        });
        //this.logo = URL.createObjectURL(file);
      });
    } else {
      if (this.navParams != undefined && this.navParams['view'] != true) {
        setTimeout(() => (this.db.print(this.options), 500));
      }
    }
  }

  ionViewDidLoad() {
    console.log('loaded');
  }

  blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function (e) {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }
}
